<template>
    <a-layout class="provisioning-layout">
        <a-row>
            <ProvisioningHeader />
            <ProvisioningTitle>
                <template #subTitle>
                    <p class="sub_title_width">
                        恭喜完成開通程序，下方為您的開通資訊：
                    </p>
                </template>
            </ProvisioningTitle>
            <ProvisioningResult @responseStatus="getResponseMsg" />
            <ProvisioningResultButton />
            <ModalApiResultMsg
            :visible="responseMsgObj.visible" 
            :title="responseMsgObj.title" 
            :okText="responseMsgObj.okText"
            :cancelText="responseMsgObj.cancelText"
            :msgClass="responseMsgObj.msgClass"
            :okCallback="responseMsgObj.msgClass === 'msg_error_modal' ? callPhoneNumber : hideModal" 
            :cancelCallback="hideModal">
            <p>{{responseMsgObj.detailText}}</p>
            </ModalApiResultMsg>
        </a-row>
    </a-layout>
</template>

<script>
    import ProvisioningHeader from "../../components/deviceProvision/ProvisioningHeader.vue";
    import ProvisioningTitle from "../../components/deviceProvision/ProvisioningTitle.vue";
    import ProvisioningResult from "../../components/deviceProvision/ProvisioningResult.vue";
    import ProvisioningResultButton from "../../components/deviceProvision/ProvisioningResultButton.vue";
    import ModalApiResultMsg from "../../components/modal/ModalApiResultMsg.vue";
    import { mixinModalMethods } from "../../utils/mixins";

    export default {
        name: 'ProvisioningResultContainer',
        components: {
            ProvisioningHeader,
            ProvisioningTitle, 
            ProvisioningResult, 
            ProvisioningResultButton,
            ModalApiResultMsg,
            
        },
        mixins: [ mixinModalMethods ],
        beforeRouteEnter(to, from, next) {
            const deviceUid = to.query.deviceUid||'';

            // 若目前頁面是step4、且上一頁來源是step3，才放行，否則導到監控地圖
            if (from.path !== '/provisioning/step3') next(`/individual/monitor?data=${deviceUid}`);
            else next();
        },
    }
</script>